// App.js
import Header from './components/Header'
import Hero from './components/Hero' 
import PlacesToVisit from './components/PlacesToVisit' 

import { ThemeProvider, createTheme } from '@mui/material/styles'

const theme = createTheme({
  typography: { 
    fontFamily: [
      'Source Sans Pro',
      'sans-serif'
    ].join(',')
  },
});

function App() {
  return (
<>
<ThemeProvider theme={theme}>
    <Header />
    <Hero/> 
    <PlacesToVisit /> 
</ThemeProvider>
</>);}
export default App;